// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.retail-configurator[data-v-71741d0c]  .holder {\r\n    display: none;\n}\n.retail-configurator[data-v-71741d0c]  .error {\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    position: absolute;\r\n    text-align: center;\r\n    width: 100%;\n}\r\n", ""]);
// Exports
module.exports = exports;
